export default "__VITE_ASSET__vmSYqjRe__"